module.exports = {
      id: "x-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.bfe893b5.svg#x-usage",
      toString: function () {
        return this.url;
      }
    }